import React from 'react' 
import Bredcom from '../../Bredcom/Main' 
import Header from '../../headerone/Main' 
import First from './First' 
// import Brand from './Brand' 
 
function BusinessManagement() { 
  return ( 
    <> 
        <Header/> 
        <Bredcom title="Home" subtitle="School of Business Management & Commerce" /> 
        <First/> 
        {/* <Brand/>  */}
    </> 
  ) 
} 
 
export default BusinessManagement 